import React from 'react';
function DesignColors({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <path
        d="M15 5.92593C13.8354 4.73743 12.2121 4 10.4167 4C6.87284 4 4 6.87284 4 10.4167C4 12.2121 4.73743 13.8354 5.92593 15"
        strokeLinecap="round"
      />
      <path d="M14 7.65039C17.507 7.65039 20.3496 10.493 20.3496 14C20.3496 17.507 17.507 20.3496 14 20.3496C10.493 20.3496 7.65039 17.507 7.65039 14C7.65039 10.493 10.493 7.65039 14 7.65039Z" />
      <path d="M8 15L15 8" strokeLinecap="round" />
      <path d="M13 20L20 13" strokeLinecap="round" />
      <path d="M10 18L18 10" strokeLinecap="square" />
    </svg>
  );
}

export default DesignColors;
